import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

const BeerIcon = props => {
  return (
    <SvgIcon
      {...props}
      viewBox="0 0 246.73 236.15"
    >
      <path d="M56.92,88a13.33,13.33,0,1,1,9.43-22.75h0A13.33,13.33,0,0,1,56.92,88Zm0-24.65a11.33,11.33,0,1,0,8,3.31A11.29,11.29,0,0,0,56.92,63.33Z" />
      <path d="M123.37,88a13.33,13.33,0,1,1,9.43-22.75h0A13.33,13.33,0,0,1,123.37,88Zm0-24.65a11.33,11.33,0,1,0,8,3.31A11.29,11.29,0,0,0,123.37,63.33Z" />
      <path d="M189.81,88a13.33,13.33,0,1,1,9.43-3.9A13.3,13.3,0,0,1,189.81,88Zm0-24.65a11.33,11.33,0,1,0,8,3.31A11.29,11.29,0,0,0,189.81,63.33Z" />
      <path d="M78.15,98A22.46,22.46,0,0,1,77,93.59L67,19a3.67,3.67,0,0,1,1.36-3.42l1.5-1.82.18-.12a.09.09,0,0,0,0-.11L68.47,9.51l2.8-1.06,1.54,4.06A3.11,3.11,0,0,1,71.87,16l-1.5,1.83-.19.12a.66.66,0,0,0-.26.64L80,93.17A18.91,18.91,0,0,0,81,97Z" />
      <path d="M35.7,98l-2.81-1a18.75,18.75,0,0,0,1-3.83l10-74.51a.68.68,0,0,0-.25-.67l-.19-.12L42,16A3.11,3.11,0,0,1,41,12.51l1.54-4.06,2.8,1.06-1.54,4.06a.12.12,0,0,0,0,.11l.18.12,1.5,1.82a3.68,3.68,0,0,1,1.35,3.44l-10,74.51A22.3,22.3,0,0,1,35.7,98Z" />
      <path d="M68.32,10.79l-.48-.48a4.11,4.11,0,0,0-5.72,0l-.44.44H60.23l-.44-.44a4.11,4.11,0,0,0-5.73,0l-.44.44H52.17l-.44-.44a4.12,4.12,0,0,0-5.73,0l-.47.48-.67,0-.34,0L44,10.66l-.37-.37a4.12,4.12,0,0,0-1.86-1l-.49-.12L41,8.72A5.37,5.37,0,0,1,45.18,0H68.66a5.37,5.37,0,0,1,4.21,8.72l-.31.4-.5.12a4.17,4.17,0,0,0-1.86,1l-.36.37-.51.06-.34,0ZM43.09,6.51a7.12,7.12,0,0,1,1.74.88,7.16,7.16,0,0,1,8.06,0,7.18,7.18,0,0,1,8.06,0,7.2,7.2,0,0,1,8.07,0,6.94,6.94,0,0,1,1.74-.88A2.45,2.45,0,0,0,71,5.38,2.39,2.39,0,0,0,68.66,3H45.18A2.39,2.39,0,0,0,42.8,5.38,2.35,2.35,0,0,0,43.09,6.51Z" />
      <rect
        x="40.85"
        y="50.8"
        width="32.15"
        height="2"
      />
      <path d="M144.59,98a22.46,22.46,0,0,1-1.15-4.44L133.4,19a3.67,3.67,0,0,1,1.35-3.42l1.5-1.82.18-.12a.12.12,0,0,0,0-.11l-1.54-4.06,2.8-1.06,1.54,4.06a3.11,3.11,0,0,1-.94,3.51l-1.5,1.83-.19.12a.66.66,0,0,0-.25.64l10,74.56a18.91,18.91,0,0,0,1,3.81Z" />
      <path d="M102.14,98l-2.81-1a19.45,19.45,0,0,0,1-3.83l10-74.51a.69.69,0,0,0-.26-.67l-.18-.12L108.42,16a3.11,3.11,0,0,1-.94-3.51L109,8.45l2.8,1.06-1.53,4.06a.1.1,0,0,0,0,.11l.18.12,1.5,1.82a3.66,3.66,0,0,1,1.35,3.44l-10,74.51A22.32,22.32,0,0,1,102.14,98Z" />
      <path d="M134.76,10.79l-.48-.48a4.11,4.11,0,0,0-5.72,0l-.44.44h-1.45l-.44-.44a4.11,4.11,0,0,0-5.73,0l-.44.44h-1.45l-.44-.44a4.11,4.11,0,0,0-5.72,0l-.48.48-.67,0-.34,0-.51-.06-.36-.37a4.15,4.15,0,0,0-1.87-1l-.49-.12-.32-.4A5.38,5.38,0,0,1,111.63,0H135.1a5.38,5.38,0,0,1,4.22,8.72l-.32.4-.49.12a4.12,4.12,0,0,0-1.86,1l-.37.37-.51.06-.34,0Zm-3.33-4.67a7,7,0,0,1,4,1.27,7.12,7.12,0,0,1,1.74-.88,2.34,2.34,0,0,0,.28-1.13A2.38,2.38,0,0,0,135.1,3H111.63a2.39,2.39,0,0,0-2.38,2.38,2.34,2.34,0,0,0,.28,1.13,6.94,6.94,0,0,1,1.74.88,7.16,7.16,0,0,1,8.06,0,7.2,7.2,0,0,1,8.07,0A6.94,6.94,0,0,1,131.43,6.12Z" />
      <rect
        x="107.29"
        y="50.8"
        width="32.15"
        height="2"
      />
      <path d="M211,98a21.81,21.81,0,0,1-1.16-4.44L199.84,19a3.65,3.65,0,0,1,1.36-3.42l1.49-1.82.19-.12a.12.12,0,0,0,0-.11l-1.54-4.06,2.81-1.06,1.54,4.06a3.12,3.12,0,0,1-.95,3.51l-1.5,1.83-.18.12a.66.66,0,0,0-.26.64l10,74.56a18.94,18.94,0,0,0,1,3.81Z" />
      <path d="M168.58,98l-2.81-1a18.78,18.78,0,0,0,1-3.83l10-74.51a.67.67,0,0,0-.26-.67l-.18-.12L174.87,16a3.12,3.12,0,0,1-1-3.51l1.54-4.06,2.81,1.06-1.54,4.06a.11.11,0,0,0,0,.11l.19.12,1.49,1.82a3.67,3.67,0,0,1,1.36,3.44l-10,74.51A21.66,21.66,0,0,1,168.58,98Z" />
      <path d="M201.2,10.79l-.47-.48a4.12,4.12,0,0,0-5.73,0l-.44.44h-1.44l-.44-.44a4.12,4.12,0,0,0-5.74,0l-.44.44h-1.44l-.44-.44a4.12,4.12,0,0,0-5.73,0l-.47.48-.68,0-.33,0-.51-.06-.37-.37a4.12,4.12,0,0,0-1.86-1l-.5-.12-.31-.4A5.37,5.37,0,0,1,178.07,0h23.48a5.37,5.37,0,0,1,4.21,8.72l-.31.4-.5.12a4.12,4.12,0,0,0-1.86,1l-.37.37-.51.06-.34,0Zm-3.33-4.67a6.94,6.94,0,0,1,4,1.27,7.3,7.3,0,0,1,1.74-.88,2.35,2.35,0,0,0,.29-1.13A2.39,2.39,0,0,0,201.55,3H178.07a2.39,2.39,0,0,0-2.38,2.38A2.45,2.45,0,0,0,176,6.51a7.18,7.18,0,0,1,1.75.88,7.14,7.14,0,0,1,8.06,0,7.16,7.16,0,0,1,8.06,0A7,7,0,0,1,197.87,6.12Z" />
      <rect
        x="173.74"
        y="50.8"
        width="32.15"
        height="2"
      />
      <path d="M246.73,236.15H0V96H246.73ZM3,233.15H243.73V99H3Z" />
      <path d="M235.87,97.5h-3V47.64a32.1,32.1,0,0,0-29.61-32c-.81-.06,0-3,1.14-2.91a35.1,35.1,0,0,1,31.47,34.87Z" />
      <path d="M43.53,15.67a32.1,32.1,0,0,0-29.66,32V97.5h-3V47.64A35.1,35.1,0,0,1,43.19,12.69Z" />
      <rect
        x="71.7"
        y="12.59"
        width="38.72"
        height="3"
      />
      <polygon points="177.58 15.59 138.14 15.59 138.14 12.59 176.09 12.59 177.58 15.59" />
      <path d="M105.71,64.27H86a13.5,13.5,0,0,1,0-27h23.18v3H86a10.5,10.5,0,0,0,0,21h19.72Z" />
      <path d="M160.75,64.27H140.8v-3h19.95a10.5,10.5,0,0,0,0-21H137.57v-3h23.18a13.5,13.5,0,1,1,0,27Z" />
      <path d="M123.37,197.43a31.36,31.36,0,1,1,31.35-31.35A31.39,31.39,0,0,1,123.37,197.43Zm0-60.71a29.36,29.36,0,1,0,29.35,29.36A29.39,29.39,0,0,0,123.37,136.72Z" />
      <path d="M131.21,214.12c-1.73,0-3.28-1.24-4.79-2.45-1-.82-2.3-1.84-3-1.84s-2,1-3.06,1.84c-1.68,1.35-3.43,2.74-5.4,2.39s-3.27-2.38-4.36-4.17c-.67-1.09-1.5-2.45-2.15-2.69s-2.22.27-3.46.68c-2.06.69-4.19,1.41-5.94.39s-2.21-3.24-2.64-5.38c-.26-1.27-.57-2.84-1.12-3.3s-2.16-.5-3.45-.53c-2.18-.05-4.43-.1-5.75-1.67s-1-3.78-.64-5.93c.19-1.28.43-2.88.07-3.51s-1.84-1.19-3-1.66c-2-.79-4.15-1.62-4.86-3.55S78,178.88,79,177c.62-1.15,1.4-2.58,1.27-3.3S79,172,78,171.11c-1.58-1.39-3.36-3-3.36-5s1.78-3.65,3.36-5c1-.84,2.15-1.89,2.26-2.56s-.65-2.16-1.27-3.31c-1-1.9-2.12-3.86-1.43-5.76s2.82-2.75,4.86-3.55c1.2-.47,2.69-1.05,3-1.66s.12-2.22-.07-3.5c-.33-2.16-.66-4.38.64-5.94s3.57-1.62,5.75-1.67c1.3,0,2.91-.07,3.45-.53s.86-2,1.12-3.3c.43-2.14.87-4.36,2.64-5.38s3.88-.3,6,.39c1.23.42,2.76.93,3.45.68s1.48-1.59,2.15-2.69c1.09-1.79,2.32-3.81,4.36-4.17s3.72,1,5.4,2.4c1,.82,2.31,1.84,3.06,1.84s2-1,3-1.84c1.68-1.35,3.43-2.74,5.4-2.4s3.27,2.38,4.36,4.17c.67,1.1,1.5,2.46,2.15,2.69s2.22-.26,3.46-.68c2.06-.69,4.19-1.41,5.94-.39s2.22,3.24,2.65,5.38c.25,1.27.56,2.84,1.11,3.3s2.16.5,3.45.53c2.18,0,4.44.11,5.75,1.67s1,3.78.64,5.94c-.19,1.28-.43,2.87-.07,3.5s1.85,1.19,3,1.66c2,.8,4.16,1.62,4.86,3.55s-.39,3.86-1.42,5.76c-.63,1.15-1.41,2.58-1.28,3.31s1.31,1.72,2.26,2.56c1.58,1.39,3.36,3,3.36,5s-1.78,3.64-3.36,5c-.95.85-2.14,1.89-2.26,2.57s.65,2.15,1.28,3.3c1,1.9,2.11,3.87,1.42,5.76s-2.82,2.76-4.86,3.55c-1.2.47-2.69,1.05-3,1.66s-.12,2.23.07,3.51c.33,2.15.66,4.38-.64,5.94s-3.57,1.61-5.75,1.66c-1.29,0-2.9.07-3.45.53s-.86,2-1.11,3.3c-.43,2.14-.88,4.36-2.65,5.38s-3.88.3-5.94-.39c-1.24-.41-2.77-.92-3.46-.68s-1.48,1.6-2.15,2.69c-1.14,1.88-2.32,3.82-4.36,4.17A3.15,3.15,0,0,1,131.21,214.12Zm-7.84-7.29c1.8,0,3.39,1.27,4.92,2.5,1,.8,2.38,1.87,3,1.78s1.63-1.66,2.31-2.78c1-1.65,2-3.35,3.69-4s3.58,0,5.43.66c1.23.41,2.91,1,3.49.64s1-2.1,1.2-3.38c.38-1.9.78-3.87,2.13-5s3.36-1.19,5.31-1.24c1.3,0,3.08-.07,3.52-.59s.17-2.28,0-3.56c-.29-1.93-.59-3.92.29-5.46s2.75-2.25,4.55-2.95c1.22-.47,2.89-1.13,3.13-1.78s-.62-2.17-1.24-3.3c-.93-1.72-1.91-3.5-1.6-5.26s1.8-3,3.24-4.3c1-.92,2.34-2.06,2.34-2.78s-1.3-1.87-2.34-2.79c-1.45-1.27-2.94-2.58-3.24-4.3s.67-3.53,1.6-5.25c.62-1.13,1.47-2.68,1.24-3.3s-1.91-1.31-3.13-1.79c-1.8-.7-3.67-1.43-4.54-3s-.59-3.53-.3-5.45c.19-1.29.46-3,0-3.56s-2.22-.57-3.52-.6c-2-.05-4-.09-5.31-1.23s-1.75-3.1-2.13-5c-.25-1.28-.6-3-1.2-3.37s-2.26.22-3.49.64c-1.85.62-3.76,1.26-5.43.65s-2.68-2.3-3.69-3.94c-.68-1.13-1.62-2.66-2.31-2.79s-2,1-3,1.79c-1.53,1.23-3.12,2.5-4.92,2.5s-3.39-1.27-4.93-2.5c-1-.8-2.36-1.9-3-1.79s-1.64,1.66-2.32,2.79c-1,1.64-2,3.34-3.69,3.94s-3.58,0-5.43-.65c-1.23-.41-2.91-1-3.49-.64s-1,2.09-1.2,3.37c-.38,1.91-.78,3.87-2.13,5s-3.36,1.18-5.31,1.23c-1.3,0-3.08.07-3.52.6s-.17,2.27,0,3.56c.29,1.92.6,3.92-.29,5.45s-2.75,2.25-4.55,3c-1.22.48-2.89,1.13-3.13,1.79s.62,2.17,1.24,3.3c.94,1.72,1.91,3.49,1.6,5.25s-1.79,3-3.24,4.3c-1,.92-2.34,2.07-2.34,2.79s1.3,1.86,2.34,2.78c1.45,1.27,2.94,2.59,3.24,4.3s-.66,3.54-1.6,5.26c-.62,1.13-1.46,2.68-1.24,3.3s1.91,1.3,3.13,1.78c1.8.7,3.67,1.43,4.55,2.95s.58,3.53.29,5.46c-.19,1.28-.45,3,0,3.55s2.22.57,3.52.6c2,.05,4,.1,5.31,1.24s1.75,3.1,2.13,5c.25,1.28.61,3,1.2,3.38s2.26-.23,3.49-.64c1.85-.62,3.76-1.27,5.43-.66s2.68,2.3,3.69,4c.68,1.12,1.62,2.66,2.32,2.78s2-1,3-1.78C120,208.1,121.56,206.83,123.37,206.83Z" />
      <rect
        x="156.86"
        y="199.1"
        width="3"
        height="42.9"
        transform="translate(-111.93 194.8) rotate(-48.88)"
      />
      <rect
        x="46.38"
        y="83.67"
        width="3"
        height="80.85"
        transform="translate(-77.09 78.55) rotate(-48.88)"
      />
      <rect
        x="197.35"
        y="167.64"
        width="3"
        height="80.85"
        transform="translate(-88.66 221.03) rotate(-48.88)"
      />
      <rect
        x="86.87"
        y="90.16"
        width="3"
        height="42.9"
        transform="translate(-53.82 104.78) rotate(-48.88)"
      />
      <rect
        x="233.66"
        y="107.44"
        width="2"
        height="109.93"
      />
      <rect
        x="222.44"
        y="107.44"
        width="2"
        height="49.8"
      />
      <rect
        x="211.44"
        y="107.44"
        width="2"
        height="30"
      />
      <circle
        cx="16.66"
        cy="219.61"
        r="3.65"
      />
      <circle
        cx="29.36"
        cy="219.61"
        r="3.65"
      />
      <circle
        cx="16.66"
        cy="207.62"
        r="3.65"
      />
    </SvgIcon>
  );
};

export default BeerIcon;
